import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import produce from 'immer';

import * as constants from './constants';
import { PAGES } from './new-year-modal.constants';

const initialState = {
    closed: {},
    newName: null,
    newLevel: null,
    loadingStatus: LOADING_STATUSES.UNSENT,
    page: PAGES.RENAME,
};

const UMKModalReducer = (state = initialState, action) => {
    // Как гласит документация [immer](https://github.com/mweststrate/immer),
    // если мы хотим заменить стейт полностью,
    // а не заменить какое-то поле в старом, то нельзя перезаписывать `draft`
    // новым объектом, нужно возвращать новый объект через `return`
    // поэтому необходимо отключить правило `consistent-return`
    //
    // eslint-disable-next-line complexity, consistent-return
    return produce(state, (draft) => {
        switch (action.type) {
            case constants.CLOSE_MODAL:
                draft.closed[action.classId] = true;
                break;
            case constants.CLEAR_STATE:
                return { ...initialState, closed: draft.closed };
            case constants.RENAME_CLASS_REQUEST:
                draft.loadingStatus = LOADING_STATUSES.LOADING;
                break;
            case constants.RENAME_CLASS_SUCCESS:
                draft.loadingStatus = LOADING_STATUSES.SUCCESS;
                break;
            case constants.RENAME_CLASS_ERROR:
                draft.loadingStatus = LOADING_STATUSES.ERROR;
                break;
            case constants.ARCHIVE_CLASS_REQUEST:
                draft.loadingStatus = LOADING_STATUSES.LOADING;
                break;
            case constants.ARCHIVE_CLASS_SUCCESS:
                draft.loadingStatus = LOADING_STATUSES.SUCCESS;
                break;
            case constants.ARCHIVE_CLASS_ERROR:
                draft.loadingStatus = LOADING_STATUSES.ERROR;
                break;
            case constants.ACTUALIZE_CLASS_REQUEST:
                draft.loadingStatus = LOADING_STATUSES.LOADING;
                break;
            case constants.ACTUALIZE_CLASS_SUCCESS:
                draft.loadingStatus = LOADING_STATUSES.SUCCESS;
                break;
            case constants.ACTUALIZE_CLASS_ERROR:
                draft.loadingStatus = LOADING_STATUSES.ERROR;
                break;
            case constants.SET_PAGE:
                draft.page = action.page;
                break;
            case constants.SET_NEW_NAME:
                draft.newName = action.name;
                break;
            case constants.SET_NEW_LEVEL:
                draft.newLevel = action.level;
                break;

            default:
                break;
        }
    });
};

export default UMKModalReducer;
